export default __webpack_public_path__ + "locales/el-GR/DataReassignmentDialog.json?hash=4b8b5ce512c84efc6b2d2f50fca99025";